import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const';

let routes: RouteRecordRaw[] = [
    {
        path: '/pdfInterpolation',
        name: 'pdfInterpolation',
        component: () => import('./views/pdfInterpolationDocuments.vue'),
        meta: { allowedRoles: [CONST.AppRoles.SuperAdmin] }
    },
    {
        path: '/pdfInterpolation/:identifier',
        name: 'pdfInterpolationDetail',
        component: () => import('./views/pdfInterpolationDocumentDetail.vue'),
        meta: { allowedRoles: [CONST.AppRoles.SuperAdmin] }
    },
];

export default routes;
